import { faWrench } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { useNumericParams } from '@domain-group/react-hooks'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import { sanitizeFilters } from '@functions/entity'

import useCurrentUser from '@hooks/useCurrentUser'
import useOrderItemTask from '@hooks/useOrderItemTask'
import useOrderItemTaskTypes from '@hooks/useOrderItemTaskTypes'
import useOrderItemTasks from '@hooks/useOrderItemTasks'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'
import OrderItemTaskListItem from './components/OrderItemTaskListItem'

import OrderItemTasksImageUrl from './assets/tasks.svg'

export const icon = faWrench

export const configOptions = () => ({
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  status_key: {
    component: 'select',
    key: 'status_key',
    label: 'Status',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All Statuses' },
      { key: 'pending', label: 'Pending' },
      { key: 'approved', label: 'Approved' },
      { key: 'complete', label: 'Complete' },
    ],
  },
  order_item_task_type: {
    component: 'select',
    key: 'order_item_task_type_key',
    label: 'Task Type',
    optionKey: 'queryParams',
    values: [
      { key: 'all', label: 'All Types' },
      { key: 'clean', label: 'Clean' },
      { key: 'install', label: 'Install' },
      { key: 'move', label: 'Move' },
      { key: 'other', label: 'Other' },
      { key: 'remove', label: 'Remove' },
      { key: 'repair', label: 'Repair' },
    ],
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 5, label: '5' },
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface OrderItemTasksProps {
  customOptions: {
    moduleProps: {
      isCampaignManager: boolean,
    },
    queryParams: {
      limit?: number,
      order_item_task_type_key?: string,
      status_key?: string,
    },
    customization: {
      title?: string,
    },
  },
  editing: boolean,
}

const OrderItemTasks = (props: OrderItemTasksProps) => {
  const {
    customOptions,
    customOptions: {
      queryParams,
    },
    editing,
  } = props

  const { customization, moduleProps } = customOptions
  const { title } = customization || {}
  const { isCampaignManager } = moduleProps || {}

  const { campaignId } = useNumericParams()

  useOrderItemTaskTypes({ performHttpRequests: true })

  const orderItemTasksPayload = useOrderItemTasks({
    filters: {
      ...sanitizeFilters(queryParams),
    },
    performHttpRequests: true,
    requestOptions: {
      include_task_order_item: true,
      // @ts-expect-error TS2353
      include_order_item_campaign_id: true,
    },
  })

  const {
    filteredOrderItemTasks,
    hasFilteredOrderItemTasks,
    loading,
  } = orderItemTasksPayload

  const orderItemTasksArray = filteredOrderItemTasks.slice(0, queryParams.limit || 10)

  const {
    callbacks: {
      createOrEditOrderItemTask,
    },
    campaign,
  } = useOrderItemTask()

  const { currentUser } = useCurrentUser()
  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })
  const canManageOrders = campaignPermissions?.orders?.manage || false

  return (
    <DashboardModule
      editing={editing}
      headerRight={canManageOrders && (
        <Link
          // @ts-expect-error TS2322
          href={isCampaignManager ? null : '#/agency/dashboard/agencies/all/overview/signboards'}
          // @ts-expect-error TS2322
          onClick={isCampaignManager ? () => createOrEditOrderItemTask({ campaign: { id: campaignId } }) : null}
          textProps={{ fontSize: 'small' }}
        >
          {isCampaignManager ? 'Add Task' : 'Manage'}
        </Link>
      )}
      loading={loading}
      title={title || 'Order Tasks'}
    >
      {!loading && !hasFilteredOrderItemTasks && (
        <DashboardModule.BlankState imageUrl={OrderItemTasksImageUrl}>
          <DashboardModule.BlankState.Title>
            No Tasks Created
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            When you add orders with tasks i.e. signboards, they will appear here.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {hasFilteredOrderItemTasks && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection maxHeight={800}>
          {orderItemTasksArray.map(orderItemTask => (
            <OrderItemTaskListItem
              campaignId={campaignId}
              canManageOrders={canManageOrders}
              key={orderItemTask.id}
              orderItemTask={orderItemTask}

            />
          ))}
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default OrderItemTasks
